export default {
  apiKey: "AIzaSyCxoSzMh_NJfJ0tJUsuYvlhd9y3UlduWmQ",
  authDomain: "neussts.firebaseapp.com",
  databaseURL: "https://neussts.firebaseio.com",
  projectId: "neussts",
  storageBucket: "neussts.appspot.com",
  messagingSenderId: "569880518939",
  appId: "1:569880518939:web:626b239989c0a7f922f3be",
  measurementId: "G-TER33TMJCJ"
};
